import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  id: "items-list",
  class: "flex flex-col gap-5"
}
const _hoisted_2 = {
  id: "actions",
  class: "flex justify-between items-center gap-3"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl" }, /*#__PURE__*/_toDisplayString("Items*"), -1)
const _hoisted_4 = {
  id: "items",
  class: "mt-5"
}
const _hoisted_5 = {
  id: "info-items",
  class: "flex justify-between items-center gap-3 bg-h-neutral-200 p-5 shadow rounded font-bold"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, /*#__PURE__*/_toDisplayString("Items criados"), -1)
const _hoisted_7 = { key: 1 }
const _hoisted_8 = {
  id: "options",
  class: "mt-10 pb-32"
}
const _hoisted_9 = {
  id: "info-options",
  class: "flex justify-between items-center gap-3 bg-h-neutral-200 p-5 shadow rounded font-bold"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("p", null, /*#__PURE__*/_toDisplayString("Opções de resposta"), -1)
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "text-2xl text-center w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_EmptyData = _resolveComponent("EmptyData")!
  const _component_ItemCard = _resolveComponent("ItemCard")!
  const _component_ResponseCard = _resolveComponent("ResponseCard")!
  const _component_OptionsCard = _resolveComponent("OptionsCard")!
  const _component_FormItems = _resolveComponent("FormItems")!
  const _component_FormOptions = _resolveComponent("FormOptions")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("section", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", null, [
          (_ctx.questionStore.options && _ctx.questionStore.options?.length < 5)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 0,
                label: "Adicionar Opções",
                icon: "pi pi-plus",
                class: "btn-simple",
                onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.openDialog('options')), ["prevent"]))
              }))
            : _createCommentVNode("", true),
          (_ctx.questionStore.items && _ctx.questionStore.items?.length < 5)
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 1,
                label: "Criar Item",
                class: "btn-outline",
                onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.openDialog('items')), ["prevent"]))
              }))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createElementVNode("section", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _createElementVNode("p", {
          class: _normalizeClass([
            { 'text-h-error-600': _ctx.items.length === 0 },
            { 'text-h-warning-600': _ctx.items.length >= 1 && _ctx.items.length < 3 },
            { 'text-h-success-600': _ctx.items.length >= 3 },
          ])
        }, _toDisplayString(_ctx.items?.length) + " " + _toDisplayString(" / 5 itens"), 3)
      ]),
      (_ctx.items?.length === 0)
        ? (_openBlock(), _createBlock(_component_EmptyData, {
            key: 0,
            data: _ctx.items?.length === 0,
            label: _ctx.emptyStateItems.description,
            image: _ctx.emptyStateItems.image,
            imgSize: "h-40 my-10",
            msgSize: "lg:w-[350px] -mt-14"
          }, null, 8, ["data", "label", "image"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
              return (_openBlock(), _createElementBlock("div", { key: index }, [
                _createVNode(_component_ItemCard, {
                  item: item,
                  "item-index": index,
                  onEditItem: _ctx.onEditItems
                }, null, 8, ["item", "item-index", "onEditItem"])
              ]))
            }), 128))
          ]))
    ]),
    _createElementVNode("section", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("p", null, _toDisplayString(_ctx.questionStore.getTotalOptions) + " " + _toDisplayString(" opções"), 1)
      ]),
      (_ctx.questionStore.getTotalOptions === 0)
        ? (_openBlock(), _createBlock(_component_EmptyData, {
            key: 0,
            data: _ctx.questionStore.getTotalOptions === 0,
            label: _ctx.emptyStateOptions.description,
            image: _ctx.emptyStateOptions.image,
            imgSize: "h-40 my-10",
            msgSize: "lg:w-[500px] -mt-14"
          }, null, 8, ["data", "label", "image"]))
        : (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_ctx.questionStore.responses?.length > 0)
              ? (_openBlock(), _createBlock(_component_ResponseCard, {
                  key: 0,
                  responses: _ctx.questionStore.responses
                }, null, 8, ["responses"]))
              : _createCommentVNode("", true),
            (_ctx.questionStore.options?.length > 0)
              ? (_openBlock(), _createBlock(_component_OptionsCard, {
                  key: 1,
                  options: _ctx.questionStore.options,
                  onEditOptions: _ctx.onEditOptions
                }, null, 8, ["options", "onEditOptions"]))
              : _createCommentVNode("", true)
          ]))
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.open,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.open) = $event)),
      breakpoints: { '960px': '75vw', '640px': '90vw' },
      style: { width: '45vw' },
      modal: true,
      draggable: false,
      onHide: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeDialog(_ctx.dialogType)))
    }, {
      header: _withCtx(() => [
        _createElementVNode("p", _hoisted_12, _toDisplayString(_ctx.dialogType === "items" ? "Criar Item" : "Adicionar opções"), 1)
      ]),
      default: _withCtx(() => [
        (_ctx.dialogType === 'items')
          ? (_openBlock(), _createBlock(_component_FormItems, {
              key: 0,
              onOnClose: _ctx.closeDialog,
              isEditing: _ctx.isEditing.items
            }, null, 8, ["onOnClose", "isEditing"]))
          : _createCommentVNode("", true),
        (_ctx.dialogType === 'options')
          ? (_openBlock(), _createBlock(_component_FormOptions, {
              key: 1,
              onOnClose: _ctx.closeDialog,
              isEditing: _ctx.isEditing.options.action
            }, null, 8, ["onOnClose", "isEditing"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}